import { TagTransformer } from '../assistants/tag.transformer';
import { TagElement } from '@core/domain/mappers/assistants/tags.directory';
import { DraftListing, ProcedureListing, ProceduresListingFilters } from '@core/domain/model/procedures/procedures-listing.model';
import { DraftListingApi, ProcedureListingApi } from '@core/api/model/my-procedures/procedures-listings-api.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { ProcedureCodes } from '@core/domain/model/procedures/procedure-codes';

export class ProcedureListingMapper {
  public static apiDataToDomain(api: ProcedureListingApi[] | DraftListingApi[]): ProcedureListing[] | DraftListing[] {
    if (api.length === 0) {
      return [];
    }
    if ('idBorrador' in api[0]) {
      return api.map((input) => ProcedureListingMapper.apiDraftToDomain(input as DraftListingApi));
    }
    return api.map((input) => ProcedureListingMapper.apiProcedureToDomain(input as ProcedureListingApi));
  }

  public static apiProcedureToDomain(api: ProcedureListingApi): ProcedureListing {
    return {
      ...api,
      isDraft: false,
      requestCode: api.codigo,
      stateCode: api.estadoCodigo,
      stateDesc: api.estado,
      stateType: TagTransformer.tagTypeFromCode(api.estadoCodigo, TagElement.PROCEDURE),
      procedureDesc: api.tipo,
      procedureCode: api.tipoCodigo,
      societyName: api.nombreRazonSocial,
      societyCode: api.codigoRazonSocial,
      installationName: api.nombreInstalacion,
      installationCode: api.codigoInstalacion,
      lastModificationDate: new Date(api.fechaUltimaModificacion),
    };
  }
  public static apiDraftToDomain(api: DraftListingApi): DraftListing {
    return {
      ...api,
      isDraft: true,
      id: api.idBorrador,
      procedureDesc: api.tipo,
      procedureCode: api.tipoCodigo,
      societyName: api.nombreRazonSocial,
      societyCode: api.codigoRazonSocial,
      installationName: api.nombreInstalacion,
      installationCode: api.codigoInstalacion,
      lastModificationDate: api.fechaUltimaModificacion,
      sendCRM: api.enviadoCRM,
      title: api.titulo,
    };
  }

  public static domainFilterToApi(paginator: PaginatorInput, filters: ProceduresListingFilters) {
    return {
      pageNumber: paginator.pageIndex,
      numOfElements: paginator.pageSize,
      filterCodSociedades: filters.societies,
      filterCodInstalaciones: filters.installations,
      filterNumTramite: filters.requestNumber,
      filterCodTramites: filters.procedureTypes?.flatMap((value) =>
        value === ProcedureCodes.HOLDER_CHANGE ? [ProcedureCodes.HOLDER_CHANGE, ProcedureCodes.HOLDER_CHANGE_SURROGATE] : [value]
      ),
    };
  }
}
